// routes/_authenticated/settings/following.tsx — /settings/following
// route surface. Reuses the watchlist feature (single source of
// truth for followed-company CRUD); the Settings page is the
// user-preferences entry point that sits next to Profile and
// Appearance.
import { createFileRoute } from "@tanstack/react-router";

import SettingsFollowing from "@/features/settings/following";

export const Route = createFileRoute("/_authenticated/settings/following")({
  component: SettingsFollowing,
});
